/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Settings_About_Sources_DescInputs */

const en_ui_settings_about_sources_desc = /** @type {(inputs: Ui_Settings_About_Sources_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bibliography for all engine formulas and algorithms`)
};

const de_ui_settings_about_sources_desc = /** @type {(inputs: Ui_Settings_About_Sources_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quellenangaben für alle Berechnungen und Algorithmen`)
};

/**
* | output |
* | --- |
* | "Bibliography for all engine formulas and algorithms" |
*
* @param {Ui_Settings_About_Sources_DescInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_settings_about_sources_desc = /** @type {((inputs?: Ui_Settings_About_Sources_DescInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Settings_About_Sources_DescInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_settings_about_sources_desc(inputs)
	return de_ui_settings_about_sources_desc(inputs)
});